export const errors = {
  first_column_doesnt_have_numbers:
    'The first line of the file does not contain a number, or the file contains column headings.',
  illegal_symbol_in_number: 'The file contains an empty line or invalid number format',
  number_must_contain_min_max_digits:
    'The phone number must be at least 5 and no more than 18 digits.',
  too_many_rows: 'The maximum number of lines in the file has been exceeded.',
  row: ' (Line {row})',
  not_found: 'not found',
  field: 'Field',
  rule: {
    check_import_file_extension: 'The file extension can be csv, xls, xlsx',
    required: 'Required field',
    file: 'The field must contain a file',
    array: 'The field must be an array',
    maxarray: 'Number of entries exceeded',
    string: 'The field must be a string',
    integer: 'The field must be an integer',
    maxnumeric: 'The value cannot be greater than',
    minnumeric: 'The value cannot be less than',
    maxstring: 'The value cannot be greater than',
    minstring: 'The value cannot be less than',
    regex: 'Invalid format',
    date_format: 'Invalid date format'
  },
  recaptcha: 'reCAPTCHA error',
  general_not_success_request: 'The request cannot be executed',
  captcha_bad_request: 'The request cannot be executed. Contact customer support'
};
